export default function (number) {
  const apNumbers = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];

  if (number < 10) {
    return apNumbers[number];
  } return number.toLocaleString('en-US');
}
